module.exports = require('./helpers/bundle-url').getBundleURL('d6OmZ') + "logo-dark.eefe0b7f.svg";